import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    tableHeader: {
      background: colors.defaultGrey
    },
    cardHeader: {
      paddingBottom: 0,
      paddingTop: 5,
      paddingLeft: 5,
      background: colors.defaultGrey
    },
    cardFooter: {
      justifyContent: 'flex-end'
    },
    numberInput: {
      maxWidth: 100
    },
    dayOfWeek: {
      minWidth: 100
    },
    listItemText: {
      maxWidth: 160
    },
    mr1: {
      marginRight: theme.spacing(1)
    }
  });
});
